const MASTER_SUBSITE_ID = 1

const getters = {
  sidebar: state => state.app.sidebar,
  token: state => state.user.token,
  name: state => state.user.name,
  visitedViews: state => state.tagsView.visitedViews,
  subSiteList: state => state.app.subSiteList,
  subSiteId: state => state.app.subSiteId,
  userInfo: state => state.user.userInfo,
  substationId: state => {
    const info = state.user.userInfo
    const id = info && (info.substation_id != null ? info.substation_id : info.substationId)
    return id != null ? Number(id) : null
  },
  substationName: state => {
    const info = state.user.userInfo
    return (info && (info.substation_name || info.substationName)) || ''
  },
  permissions: state => {
    const info = state.user.userInfo
    return (info && info.permissions) || '[]'
  },
  // 驿站管理员：绑定了真实驿站（>0 且非总站 ID）
  isStationAdmin: state => {
    const info = state.user.userInfo
    const id = info && (info.substation_id != null ? info.substation_id : info.substationId)
    const num = id != null ? Number(id) : 0
    return num > 0 && num !== MASTER_SUBSITE_ID
  }
}
export default getters
